export default __webpack_public_path__ + "48e273e7a7da3eccd60ce72cd82837b9.svg";